// dwarrow-folk
import { assembleDictionary, Dictionary, Roots } from "../Dictionary";
const khuzdulRoots: Roots = {
  beauty: 'kib', // 'ea',
  ore: 'il',
  water: '-na',
  way: 'la',

  air: 'aer',
  all: 'ere',
  at: 'es-',
  bad: 'nu',
  bear: 'gruw',
  bell: 'bjel',
  bitter: 'mé',
  cold: 'í',
  color: 'o',
  crown: 'ar',
  cut: 'kh',
  daughter: 'al',
  death: 'lun',
  deep: 'yse',
  dog: 'hu',
  drink: 'ik',
  eat: 'zu',
  fear: 'ga',
  fight: 'kla',
  flower: 'ela',
  good: 'lu',
  great: 'agh',
  hard: 'ekh',
  heart: 'eru',
  heat: '-hrond', //thu',
  high: 'tl',
  horse: 'raph',
  joy: '-hyt',
  light: 'ia-',
  man: '-rhd',
  mantle: '-manté', //brae',
  many: 'ah',
  mere: 'sea',
  mound: 'haeth',
  no: 'u-',
  one: 'eru',
  over: 'ya-',
  place: 'n-',
  point: '-zirak',
  quick: 'ea-',
  run: 'r',
  safe: '-cúa',
  shadow: 'uz',
  sing: 'ina',
  sleep: '-dre',
  small: 'eai',
  snake: 'lug',
  soft: 'i',
  son: 'on',
  sorrow: 'srg',
  strong: 'elu',
  sweet: 'hlor',
  tall: 'mu-',
  time: 'an',
  tooth: 'tur',
  tree: 'an',
  wing: 'hla',
  woman: 'an',
}

const khuzdulVocab = {
  // common: '',
  // dwarvish: 'khuzdul',

  // jewel: 'silmaril',
  // // horn: 'horn',
  // summer: 'samhradh', //sumrum',
  // prison: 'kharkhor', //carcern', //fengsel',
  // iron: 'jern',
  // holly: 'kristtorn',
  // land: '-lann', // jord',
  // mountain: 'fell', //'fjell',
  // 'mountain-chain': 'fellkjede',
  // peak: 'felltindr',
  // bay: 'vik-',
  // stars: '-sterne',
  // silence: '-stille',
  // // silver: 'sølv',
  // river: 'elv',
  // ice: 'yses', //is',
  // icy: 'iskald',
  // fangs: 'hoggtann',
  // dragons: 'drager',
  // giant: 'kjempe',
  // hill: 'høyde',
  // golden: 'gyllen',
  // gold: 'gull',
  // music: 'musikk',
  // pine: 'furu',
  // eagles: 'orn-',
  // gray: 'liath-',
  // stronghold: 'daingneach', //bfort',
  // tyranny: 'dyren-', // 'tiren-', //grusomhet',
  // nightingales: 'nattergal',
  // vale: 'dal',
  // valley: 'dalr',
  // magic: 'seith',
  // '-woman': '-kona', //víf',

  // haven: '-cúan', //'höfn',
  // swans: 'eala', // swoon', //'sisne', //'cygnus',
  // day: 'dagaz', //

  // cherry: 'kerásion',
  // // mist: 'niwl', // also like (icelandic for fog): fjúka

  // // actual khuzdul vocab!!
  // laughter: 'gàire',
  // spring: 'earrach',

  // lonely: 'ensam',
  // isle: 'ö',

  mist: 'nevel',
}

const trueKhudzulVocab = {
  speech: 'aglâb', //agbla'
  lord: 'uzbad',
  path: 'nâla', // river-course
  river: 'nâla', // river-course
  water: 'nâla', // river-course
  black: 'narâg',
  cloud: 'shathûr',
  lake: 'zâram',
  pool: 'zâram',
  silver: 'kibil-', // 'zigil',
  stream: 'ûl',
  // river: 'ûlnâla', // river-course
  horn: 'inbar',
  fortress: 'gathol',
  dark: 'azan',
  red: 'baraz',
  valley: 'duban',
  great: 'gabil',

  delve: 'dûm',
  // dream: 'draumr',
  autumn: 'salôn', // lit. "fall"

  
}

// todo add some vocab too? shield -- skjald
// and override: oak -- eik
const khuzdul: Dictionary = assembleDictionary('Khuzdul',
  khuzdulRoots,
  {
    // great: 'gabil',
    ...khuzdulVocab,
    ...trueKhudzulVocab
  },
  {
    'kibeah': 'ea',
    'ia': 'e',
    'hrond': 'th',
    'ee': 'i',
    'ae': 'e',
    'elu': 'lu',
    'esa': 'as',
    'gh': 'g',
    'hd': 'd',
    'ag': 's',
    'anan': 'a',
    'he': 'e',
    'rdn': 't',
    'ly': 'i',
    'ah': 'r',
    'tl': 'r',
    'yse': 'is',
    'ss': 'z',
    'srg': 'zh',
    'sre': 'se',
    'a r': 'ah',
    'l m': 'n',
    'g m': 'k',
    'aa': 'u',
    'thn': 't',
    'eo': 'u',
    'rdr': 'l',
    'sna': 'se',
    'a s': 'sh',
    'th s': 'st',
    'th u': 'w',
    'eai': 'a',
    'kho': 'cu',
    'sr': 'sur',
    'iti': 'ut',
    'rg': 'u',
    'thz': 'thus',
    'ise': 'se',
    'dre': 'li',
    'rdi': 'no',
    'na': 'r',

    'rr': 'r',
    'tth': 'shi',
    // 'yrso': 'ara',
    // 'bre': 'gorn',
    'serl': 'ar',
    'ahie': 'agorn',
    
    'uu': 'w',
    'wz': 'yrs',
    'st': 'm',
    'cuk': 'kh',
    'rdz': 'ts',
    'rl': 'l',
    'wts': 'uz',
    'tiu': 'reg',
    'lt': 'nd',
    
    
    // 'bre': 'vr',
    // 'wz': 's',
    // 'sre': 'st',
    // 'esa': 'as',
    // // 'nhd': 'rd',
    // // 'hh': 'g',
    // // 'ii': 'y',
    // 'rr': 'r',
    // 'rh': 'r',
    // 'ysen': 'iso',
    // 'eai': 'o',
    // 'ao': 'e',
    // 'ui': 'o',
    // 'oe': 'u',
    // 'ua': 'ie',
    // // 'oa': 'e',
    // 'mrd': 'v',
    // 'gh': 'g',
    // 'aa': 'a',
    // 'ndi': 't',
    
    
    // 'dard': 'drem',
    // 'adard': 'e',

    // 'eru': 'ui'
  //   // 'eth': 'sh',
  //   // 'erue': 'er',
  //   'esa': 'as',
  //   'yseold': 'iso',
  //   'oa': 'o',
  //   // 'ae': 'y',
  //   'ea': 'y',
  //   'yy': 'ea',
  //   // 'hl': 'l',
  //   // 'agh': 'g',
  //   'uia': 'a',
  //   'aya': 'ie',
  //   // 'eya': 'ea',


  //   // 'rrh': 'r',
  //   'ao': 'u',
  //   // 'uu': 'w',
  //   // 'gtl': 'l',
  //   // 'nn': 'm',
  //   // 'ui': 'i',
  //   'rhd': 'd',
  //   'nina': 'nia',
  //   'ghart': 'gard',
  //   'rdt': 'dh',
  //   'asgh': 'asg',
  //   'elut': 'lût',
  //   'úun': 'úan',
  //   'ahla': 'ala',
  //   'aght': 'og',
  //   'yhl': 'il',
  //   'ogl': 'gel',
  //   'thanth': 'tan',
  //   'ila': 'ye',
  //   'ss': 'th',
  //   'tly': 'y',
  //   'dan': 'del',
  //   'ht': 'd',
  //   'dad': 'ed',
  //   'aeta': 'eth',
  //   'agh': 'zh',
  //   'thun': 'tr',
  //   'yseo': 'iso',
  //   'ved': 'th',
  //   'ndn': 'nyn',

})

export default khuzdul;
